/** Phase 20 */
import { getAggregateBusinessInfo } from '../infrastructure/storage/domainAggregateStore';
import { getEntityBusinessInfo } from '../infrastructure/storage/entityAggregateStore';
import { createRootDocumentEntityReadSource } from './rootDocumentEntityReadSourceFactory';

const source = createRootDocumentEntityReadSource({
  field: 'businessInfo',
  getEntity: getEntityBusinessInfo,
  getAggregate: getAggregateBusinessInfo,
  emptyValue: null
});

export const readBusinessInfoFromMergedBlob = source.readFromMergedBlob;
export const readBusinessInfoFromBestSource = source.readFromBestSource;
export const refreshBusinessInfoReadCache = source.refreshReadCache;
export const getCachedBusinessInfoRead = source.getCachedRead;
export const clearBusinessInfoReadCache = source.clearReadCache;
export const readBusinessInfoSyncForBusiness = source.readSyncForBusiness;
